module.exports = __webpack_public_path__ + "media/feature-icons/reference_data-2ee5ebd2.png";